import { Group } from "@visx/group";
import { Line } from "@visx/shape";
import type { DateScale } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import { TransportNeedGraphPoint } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import {
  formatTime,
  getDate,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";
import { FC } from "react";
import { Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

const MARKING_HEIGHT = 12;

interface DataPointTimeLabelsProps {
  data: TransportNeedGraphPoint[];
  dateScale: DateScale;
  yMax: number;
}

export const DataPointTimeLabels: FC<DataPointTimeLabelsProps> = ({
  data: chartData,
  dateScale,
  yMax,
}) => {
  const theme = useTheme();

  if (chartData.length === 0) {
    return <Group />;
  }

  // first marker at at the start
  const startIndex = 0;
  const first = chartData[startIndex];
  const last = chartData[chartData.length - 1] ?? first;
  const firstMarker = first;
  const lastMarker = last;

  const dataPoints = [firstMarker, lastMarker];

  return (
    <Group>
      {dataPoints.map((d) => {
        const cx = dateScale(getDate(d));
        const pointKey = `${d.date.getTime()}-${d.passengers}`;

        return (
          <Group key={`group-${pointKey}`}>
            <Line
              key={`line-${pointKey}`}
              x1={cx}
              x2={cx}
              y1={yMax - MARKING_HEIGHT / 2}
              y2={yMax + MARKING_HEIGHT / 2}
              stroke={theme.colorTextSecondary}
              strokeWidth={1}
            />
            <foreignObject y={yMax + 11} x={cx - 20} width={40} height={22}>
              <Text
                fontSize="14px"
                textAlign="center"
                color={theme.colorTextSecondary}
              >
                {formatTime(getDate(d))}
              </Text>
            </foreignObject>
          </Group>
        );
      })}
    </Group>
  );
};
